import http, {configForm, configJson} from "./config/http-configs";

//department
export const addDepartment = (department) => {
    const url = "/manage/contact/department/add"
    return http.post(url, department, configJson)
}

export const updateDepartment = (department) => {
    const url = "/manage/contact/department/update"
    return http.post(url, department, configJson)
}


export const deleteDepartmentByBatch = (departmentIds) => {
    const url = "/manage/contact/department/delete/batch"
    return http.post(url, departmentIds, configJson)
}


export const getAllDepartment = () => {
    return http.get('/manage/contact/department/all')
}

export const getEmployeeByIds = (employeeIds) => {
    const url = `/manage/contact/employee/ids/list?employeeIds=${employeeIds}`
    return http.post(url, null, configForm)
}

//employee
export const addEmployee = (employee) => {
    const url = "/manage/contact/employee/add"
    return http.post(url, employee, configJson)
}

//employee
export const addEmployeeList = (employeeList) => {
    const url = "/manage/contact/employee/add/batch"
    return http.post(url, employeeList, configJson)
}

export const updateEmployee = (employee) => {
    const url = "/manage/contact/employee/update"
    return http.post(url, employee, configJson)
}

export const deleteEmployee = (employeeId) => {
    return http.get('/manage/contact/employee/delete/' + employeeId)
}

export const deleteEmployeeByBatch = (employeeIds) => {
    const url = "/manage/contact/employee/delete/batch"
    return http.post(url, employeeIds, configJson)
}

export const getEmployeeByPage = (pageNum, pageSize, searchName) => {
    const url = '/manage/contact/employee/all/direct/page'
    const postData = {current: pageNum, size: pageSize, name: searchName}
    return http.post(url, postData, configJson)
}

export const getEmployeeByPage2 = (postData) => {
    const url = '/manage/contact/employee/all/direct/page'
    return http.post(url, postData, configJson)
}

export const getDepartmentEmployeeByPage = (departmentId, pageNum, pageSize, employeeName) => {
    const url = '/manage/contact/employee/all/department/page'
    const postData = {current: pageNum, size: pageSize, departmentId: departmentId, name: employeeName}
    return http.post(url, postData, configJson)
}

export const guardSearchEmployee = (employee) => {
    const url = `/manage/contact/employee/search`
    return http.post(url, employee, configJson)
}


export const getEmployeeByBatch = (employeeCodes) => {
    const url = `/manage/contact/employee/list?employeeCodes=${employeeCodes}`
    return http.post(url, null, configJson)
}
